<template>
  <div style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner3.png" alt="" />
    <div class="main">
      <ul class="Breadcrumb" v-if="languageCode == 'zh'">
        <li @click="backPage('/home')">首页</li>
        <li>></li>
        <li @click="backPage('/apply')">行业应用</li>
        <li>></li>
        <li>{{ apply.name }}</li>
      </ul>
      <ul class="Breadcrumb" v-else>
        <li @click="backPage('/home')">Home</li>
        <li>></li>
        <li @click="backPage('/apply')">Application</li>
        <li>></li>
        <li>{{ apply.name }}</li>
      </ul>
      <div class="content">
        <div class="menu">
          <Menu :mebuActive="active" @changeBreadcrumb="changeBreadcrumb" />
        </div>
        <div class="apply">
          <h2 class="tab_title title">{{ apply.name }}</h2>
          <div class="editor" v-html="apply.content"></div>
          <div class="editor" v-html="apply.description"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from "./compontents/menu.vue";
import { getApplyDetail } from "../../api/index";
export default {
  components: {
    Menu,
  },
  data() {
    return {
      type: "",
      name: "",
      content: "",
      apply: {},
      active: null,
      id: "",
      content: "",
    };
  },
  computed: {
    languageCode() {
      // 注意：根据你项目实际使用的 i18n 实例名称来写
      // 常见的是 this.$i18n.locale
      // 如果确实用了 this.$i18nState，就保留
      return this.$i18nState.locale ? this.$i18nState.locale : "zh";
    },
  },
  methods: {
    getLocalizedPath(rawPath) {
      const currentLang = this.$i18nState.locale || "zh";
      // 如果路径已经以 /zh 或 /en 结尾，则直接返回
      if (/\/(zh|en)$/.test(rawPath)) {
        return rawPath;
      }
      // 移除路径末尾多余的斜杠，然后添加语言
      const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return `${base}/${currentLang}`;
    },
    changeBreadcrumb(item) {
      this.type = item.name;
      // localStorage.setItem('type',this.type)
    },
    backPage(page) {
        const fullPath = this.getLocalizedPath(page);
        this.$router.replace({ path: fullPath });
    },
  },
  mounted() {
    this.active = this.$route.query.active;
    console.log(this.active);
    this.id = this.$route.query.id;
    getApplyDetail(this.id).then((res) => {
      this.apply = res.data;
    });
  },
};
</script>
<style lang="scss" scoped>
.ql-snow .ql-tooltip[data-mode="img"]::before {
  content: "http://admin.cimomicro.com/prod-api:";
}
.content {
  display: flex;
  .menu {
    width: 250px;
  }
  .apply {
    padding: 0 20px;
    .title {
      margin-bottom: 30px;
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply/applyDetail.vue